import { useState } from 'react';
import {
  useGetAnnouncementTypeAllQuery,
  useCreateAnnouncementTypeAsyncMutation,
  useUpdateAnnouncementTypeMutation,
  useDeleteAnnouncementTypeMutation,
} from '../../../../api';
import toastService from '../../../../utils/toastService';
import { useLanguage } from '../../../../contexts/LanguageContext';

const useAnnouncementTypeData = () => {
   const { getCurrentLanguageId, th } = useLanguage();
  const [lazyParams, setLazyParams] = useState({ first: 0, rows: 10, page: 1 });
  const [activeFilters, setActiveFilters] = useState({
    type: '',  
  });
    const languageId = getCurrentLanguageId();

  const { data: announcementTypeApi, isLoading, isFetching, error, refetch } =
    useGetAnnouncementTypeAllQuery({
      pageNumber: lazyParams.page,
      pageSize: lazyParams.rows,
      languageId: languageId,
      type:
        Array.isArray(activeFilters.type)
          ? (activeFilters.type[0] ?? undefined) 
          : (activeFilters.type || undefined),
    }, {
      refetchOnMountOrArgChange: true,
    });

  const [deleteMutation] = useDeleteAnnouncementTypeMutation();
  const [updateMutation] = useUpdateAnnouncementTypeMutation();
  const [createMutation] = useCreateAnnouncementTypeAsyncMutation();

  const saveAnnouncementType = async (data) => {
    try {
      if (data.id) {
        await updateMutation(data).unwrap();
        toastService.success('Duyuru Tipi başarıyla güncellendi');
      } else {
        await createMutation(data).unwrap();
        toastService.success('Duyuru Tipi başarıyla eklendi');
      }
      refetch();
      return true;
    } catch (e) {
      toastService.error('Duyuru Tipi kaydedilirken bir hata oluştu');
      return false;
    }
  };

  const deleteAnnouncementType = async (id) => {
    try {
      await deleteMutation(id).unwrap();
    } catch {
      await deleteMutation({ id }).unwrap();
    }
    refetch?.();
  };
const handleFilterChange = (updated) => {
  let nextType = updated.type ?? '';
  if (Array.isArray(nextType)) nextType = nextType[0] ?? ''; // multiSelect ise
  if (nextType !== '' && typeof nextType !== 'number') nextType = Number(nextType);
  setActiveFilters((p) => ({ ...p, type: Number.isNaN(nextType) ? '' : nextType }));
  setLazyParams((p) => ({ ...p, first: 0, page: 1 }));
};

  const onPage = (event) => {
    setLazyParams((prev) => ({
      ...prev,
      page: event.page + 1,
      first: event.first,
      rows: event.rows,
    }));
  };

  const initFilters = () => {
    setActiveFilters({ type: '' });
    setLazyParams((prev) => ({ ...prev, first: 0, page: 1 }));
  };

  return {
    announcementTypeApi: announcementTypeApi || { items: [], totalCount: 0 },
    isLoading,
    isFetching,
    error,
    lazyParams,
    handleFilterChange,
    initFilters,
    onPage,
    saveAnnouncementType,
    deleteAnnouncementType,
    refetch,
    activeFilters,
  };
};

export default useAnnouncementTypeData;
